var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    _vm._b(
      {
        attrs: {
          disabled: _vm.disabled || _vm.exporting,
          loading: _vm.exporting,
        },
        on: { click: _vm.exportData },
      },
      "el-button",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default"),
      !_vm.$slots.default ? [_vm._v(_vm._s(_vm.$t("exportText")))] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }